import {useQuery } from "@tanstack/react-query";
import {getMemebersTransactionReport} from "../../service/query/auth";

export const useGetMemebersTransactionReport = ({ payload, page }) => {
  const getAllMemebersTransactionReport= useQuery({
    queryKey: ['MemebersTransactionReport', payload, page],
    queryFn: () => getMemebersTransactionReport({ ...payload, page }),
    enabled: !!payload && !!page,
    keepPreviousData: true,
  },
);
  return {data:getAllMemebersTransactionReport?.data?.data,  ...getAllMemebersTransactionReport,}
};